export type AdminBadgeColor =
  | "positive"
  | "negative"
  | "warning"
  | "primary"
  | "secondary"
  | "accent"
  | "grey";

// SteamBotOfferState на бэкенде (= статусы трейд-офферов Steam);
// им же пользуются provideroffers
export const OFFER_STATES: Record<
  string,
  { name: string; label: string; color: AdminBadgeColor }
> = {
  "-1": { name: "UNKNOWN", label: "Неизвестно", color: "grey" },
  "0": { name: "NOT_CREATED", label: "Не создан", color: "grey" },
  "1": { name: "INVALID", label: "Невалидный", color: "negative" },
  "2": { name: "ACTIVE", label: "Активен", color: "primary" },
  "3": { name: "ACCEPTED", label: "Принят", color: "positive" },
  "4": { name: "COUNTERED", label: "Встречный", color: "warning" },
  "5": { name: "EXPIRED", label: "Истёк", color: "warning" },
  "6": { name: "CANCELLED", label: "Отменён", color: "negative" },
  "7": { name: "DECLINED", label: "Отклонён", color: "negative" },
  "8": { name: "INVALID_ITEMS", label: "Нет предметов", color: "negative" },
  "9": {
    name: "CREATED_NEEDS_CONFIRMATION",
    label: "Ждёт подтв.",
    color: "warning"
  },
  "10": {
    name: "CANCELLED_BY_SECOND_FACTOR",
    label: "Отменён 2FA",
    color: "negative"
  },
  "11": { name: "IN_ESCROW", label: "Удержание", color: "accent" }
};

// ProviderItemEnum на бэкенде
export const PROVIDERS: Record<
  string,
  { label: string; icon: string; color: AdminBadgeColor }
> = {
  STEAM: { label: "Steam", icon: "fab fa-steam", color: "primary" },
  SKINIFY: { label: "Skinify", icon: "fas fa-store", color: "accent" },
  SKINS_BACK: {
    label: "SkinsBack",
    icon: "fas fa-box-open",
    color: "secondary"
  }
};
